import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import withStyles from "components/with-styles";
import styles from "../styles/source-data.css.js";
import { SimpleButton } from "components/buttons";
import OptionalDate from "components/optional-date";
import { Restricted, permissions } from "components/auth";
import FormHelperText from "components/form/form-helper-text";

const RestartData = ({ classes, source, intl, onRestartSource }) => {
  const disableRestart = Boolean(source && source.firstActiveEventRelated && source.firstActiveEventRelated.id);

  return (
    <DataGrid>
      <DataGridItem big>
        <OptionalDate label={intl.formatMessage({ id: "source.firstSeen" })} value={source.firstSeen} />
      </DataGridItem>
      <Restricted permissions={[permissions.admin_view]}>
        <DataGridItem big>
          <SimpleButton
            disabled={disableRestart}
            onClick={onRestartSource}
            icon="cached"
            label={intl.formatMessage({ id: "source.operations.restart" })}
          />
          {disableRestart && (
            <FormHelperText text={intl.formatMessage({ id: "source.operations.restart.hasActiveEvents" })} />
          )}
        </DataGridItem>
      </Restricted>
    </DataGrid>
  );
};

RestartData.propTypes = {
  /**
   * Data to represent
   **/
  source: PropTypes.object,
  /**
   * Callback que se invoca al clicar el botón de reiniciar la cámara
   **/
  onRestartSource: PropTypes.func,
};

export default injectIntl(withStyles(styles)(RestartData));
